<template>
    <svg class="gj-icon" :height="size" :width="size" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor" v-html="getIcon"></svg>
</template>

<script>
import GjIconLoader from './GjIconLoader.js'
import packageJson from './package.json'

export default {
  props: {
    name: {
      type: String,
      default: 'Article'
    },
    folder: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: '24'
    }
  },
  data() {
    return {
      icon: ''
    }
  },
  watch: {
    name: {
      immediate: true,
      handler() {
        this.loadIcon()
      }
    }
  },
  computed: {
    getIcon() {
      return this.icon.replace(/<svg[^>]*>/g, '').replace(/<\/svg>/g, '');
    },
  },
  methods: {
    async loadIcon() {
      // Load icon
      GjIconLoader(this.folder || packageJson?.version || '0.2.2' , this.name)
        .then((data) => {
          // Set icon
          this.icon = data
        })
        .catch((err) => {
          // Load default icon, if icon not found
          GjIconLoader(this.folder || packageJson?.version || '0.2.2' , 'Article')
            .then((data) => {
              // Set default icon, if found
              this.icon = data
            })
            .catch((err) => {
              // Set empty icon, if all fails
              this.icon = ''
            })
        })
    }
  }
}
</script>

<style>
.gj-icon * {
  fill: currentColor;
}
</style>